import { useEffect } from 'react';

export const useEscapeKey = (enabled: boolean, onEscape: () => void): void => {
    useEffect(() => {
        if (!enabled) return;
        const handler = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onEscape();
        };
        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, [enabled, onEscape]);
};